export enum PostMessageAction {
  APP_LOAD = 'app-load',
  STEP_CHANGE = 'step-change',
  REDIRECT = 'redirect'
}

export const sendMessage = <T>(action: PostMessageAction, data: T) => {
  const event = { source: 'registry-360', action, data };

  if ((window as any)?.ReactNativeWebView?.postMessage) {
    (window as any)?.ReactNativeWebView?.postMessage(JSON.stringify(event));
    return;
  }

  top?.postMessage(event, '*');
};
